var template = require('./template.pug');
var Promise = require('bluebird');
var ReportAPI = require('../../../common/api').Report;
var FileHandler = require('../../../common/api').FileHandler;

 angular
  .module("app.directives")
  .directive("reportList", function ($timeout, $parse, $document, ngDialog) {
    return {
      restrict: 'E',
      scope: {
        reportList: "=",
        funderId: "=?",
        applicationId: "=?",
        applicantId: "=?",
        userId: "=?",
        isCombo: "=?"
      },
      template: template,

      link: function (scope, element, attrs) {
        scope.nreport = null;       

        function getExportType(et){
          var exportType = {
            extension: '.pdf',
            mimeType: '',
            type: 0
          };

          switch(et){
            case 1:
              exportType.mimeType = 'application/vnd.ms-excel';
              exportType.extension = '.xls'
              exportType.type = 1;
            break;
            case 2:
              exportType.mimeType = 'application/vnd.msword';
              exportType.extension = '.doc'
              exportType.type = 2;
            break;  
            default:
            break;
          }

          return exportType;
        }

        scope.getSelectedReport = function (report) {
          ReportAPI.GetReportFields(report.id).then(function (reportFieldsFromServer) {
            return ngDialog.open({
              template: require("./dialogs/getReport.pug")(),
              controller: require("./dialogs/getReport"),
              plain: true,
              disableAnimation: true,
              resolve: {
                reportFields: function () { return reportFieldsFromServer; }
              }
            }).closePromise.then(function (obj) {
              if (obj.value.action == 'confirm') {
                if (scope.funderId) {
                  obj.value.value['funderId'] = scope.funderId;
                }

                if (scope.applicationId) {
                  obj.value.value['applicationId'] = scope.applicationId;
                }

                if (scope.applicantId) {
                  obj.value.value['applicantId'] = scope.applicantId;
                }

                if (scope.userId) {
                  obj.value.value['userId'] = scope.userId;
                }

                var qry = {
                  reportId: report.id,
                  reportPath: report.path,
                  reportName: report.name,
                  reportDescription: report.description,
                  type: report.reportType,
                  reportParams: obj.value.value,
                  exportType: report.exportType
                };

                //defaults to .pdf
                var etValue = 0;
                if(report.exportType){
                  etValue = report.exportType
                }

                var et = getExportType(etValue);

                ReportAPI.GetReport(qry).then(function (data) {
                  var filename = qry.reportName + et.extension;
                  var streamMime = et.mimeType;

                  FileHandler.DownloadFileWithGivenName($document, $timeout, data, filename, streamMime);
                    scope.loading = false;
                  });
                if (obj.action == 'cancel') {

                }
              };
            })
          })
        }
      }
    }
  })

